import calc from 'calculatorjs'

function positiveAmount (value) {
  if (typeof value !== 'number' && typeof value !== 'string') return 0
  const amount = Number(value)
  return Number.isFinite(amount) && amount > 0 ? amount : 0
}

// 登记品名只判断已有货值，不使用免费保价对 mock 商品的排除规则。
export function getParcelRegistrationAmount (parcel) {
  const extraInfo = parcel?.extraInfo
  const parcelAmount = positiveAmount(extraInfo?.tpttAmount)
  if (parcelAmount) return parcelAmount

  const groups = new Map()
  for (const item of extraInfo?.tpTaobaoTradeItems || []) {
    const key = item.tradeid || item.itemTradeid || item.traTrackingNo || item.itemTrackingNo || 'parcel'
    if (!groups.has(key)) groups.set(key, [])
    groups.get(key).push(item)
  }

  let amount = 0
  for (const items of groups.values()) {
    // 同一交易的 traAmountAvg 会出现在多件商品上，只取一次。
    const tradeAmount = items.map(item => positiveAmount(item.traAmountAvg)).find(Boolean)
    const itemAmount = tradeAmount || items.reduce((total, item) => {
      const isRegistered = item.itemTag === 'TRADEPROP'
      const isQimen = item.itemTag === 'QIMEN'
      const isReference = item.itemBrief === 'mock' || item.traStatus === 'mock' || item.itemTag === 'WHSE'
      if (isReference && !isRegistered && !isQimen) return total

      // itemPriceQtyAvg 已是商品总价，不能再乘数量。
      let value = positiveAmount(item.itemPriceQtyAvg)
      if (!value && isQimen) {
        value = positiveAmount(calc.mul(positiveAmount(item.itemQty), positiveAmount(item.itemFinalPrice)))
      }
      return calc.add(total, value)
    }, 0)
    amount = calc.add(amount, itemAmount)
  }
  return positiveAmount(amount)
}

export function getParcelRegistrationPricing (parcel, model) {
  const amount = getParcelRegistrationAmount(parcel)
  const requiresPrice = !amount
  // 沿用接口既有的“数量 1 + 包裹总价”传法，不从参考商品或旧表单取价。
  const itemQty = requiresPrice ? model.itemQty : 1
  const itemPrice = requiresPrice ? model.itemPrice : amount
  const valid = Number.isInteger(Number(itemQty)) && positiveAmount(itemQty) > 0 && positiveAmount(itemPrice) > 0
  return {
    requiresPrice,
    itemQty,
    itemPrice,
    valid,
    tradeProp: requiresPrice ? { itemQty, itemPrice, trpLics: [] } : undefined,
  }
}
